import React from "react";
import { useTable } from "react-table";

const StockedItems = ({ woStatus }) => {
  // Filter the data to include only items where Special is false
  const filteredData = woStatus.filter((item) => item.Special === false);

  // Define the table columns
  const columns = React.useMemo(
    () => [
      {
        Header: "Product Code",
        accessor: "ProductCode",
      },
      {
        Header: "Description",
        accessor: "Description",
        Cell: ({ cell: { value } }) => value[1], // Join array values into a string
      },
      {
        Header: "Quantity",
        accessor: "Quantity",
      },
    ],
    []
  );

  // Table rendering logic
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({
      columns,
      data: filteredData,
    });

  return (
    <div className="flex w-full flex-col">
      <h2 className="mb-2 text-lg font-bold tracking-tight">Stocked Items</h2>

      <div className="app-card overflow-hidden rounded-2xl border">
        <div className="overflow-x-auto">
          <table {...getTableProps()} className="app-table text-base">
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => (
                    <th {...column.getHeaderProps()} className="!text-sm">
                      {column.render("Header")}
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {rows.map((row) => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()}>
                    {row.cells.map((cell) => (
                      <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default StockedItems;
